import { ThemeProvider } from "@mui/material";
import HOC from "../../../components/HOC";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import CopyPrescription from "../../../components/screen/patientCare/prescriptionHistory/CopyPrescription";
import { theme } from "../../../components/constants/muiTheme";

const MakeCopyPrescriptionPage = () => {
  return (
    <PageTemplate
      header="Make Prescription Copy"
      mainComponent={
        <ThemeProvider theme={theme}>
          <CopyPrescription />
        </ThemeProvider>
      }
      pageRole={26}
    />
  );
};

export default HOC(MakeCopyPrescriptionPage);
